const Progress = theme => ({
	root: {
		backgroundColor: theme.colors.light.neutral.secondary,
	},
	bar: {
		backgroundColor: theme.colors.light.info.default,
	},
});

export {Progress};